import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { finalize, map } from 'rxjs';
import { DocumentTemplateService as ComponentService } from '../document-template.service';
import { DocumentCategoryService } from '../../document-category/document-category.service';
import { CerereTypeService } from '../../cerere-type/cerere-type.service';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import {
    DocumentTemplate as objectPayload,
    DocumentTemplateAddPayload as objectAddPayload,
    DocumentTemplateEditPayload as objectEditPayload,
    DocumentTemplateForm as objectForm,
} from '../document-template.interface';

import { AngularEditorConfig } from '@kolkov/angular-editor';
import { initializeEditor } from 'src/app/utils/storage/editorConfig';
import { RegistreService } from '../../registre/registre.service';
import Swal from 'sweetalert2';

import { conditionalRequiredValidator } from '../../../../validators/conditional-formating'; // Ensure this path is correct

@Component({
    selector: 'app-add-document-template',
    templateUrl: './add-document-template.component.html',
    styleUrls: ['./add-document-template.component.scss'],
})
export class AddDocumentTemplateComponent implements OnInit {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;
    destination = 'toPrimarie';

    editorConfig!: AngularEditorConfig;
    is_address: boolean = false;
    registru_necessary: boolean = false;
    document_generabil_dual: boolean = false;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        context: new FormControl(''),
        context_cetatean: new FormControl(''),
        type_id: new FormControl('', [Validators.required]),
        registru_id: new FormControl(''),
        is_address: new FormControl(this.is_address, []),
        registru_necessary: new FormControl(this.registru_necessary, []),
        document_generabil_dual: new FormControl(this.document_generabil_dual, []),
        destination: new FormControl(this.destination, [])
    }, { validators: conditionalRequiredValidator('registru_id', 'registru_necessary', true) });
    cereriTypes$: any = [];
    registre$: any = [];

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    constructor(
        private dialogRef: MatDialogRef<AddDocumentTemplateComponent>,
        private componentService: ComponentService,
        private notificationService: NotificationService,
        private documentCategoryService: DocumentCategoryService,
        private authService: AuthService,
        private cerereTypeService: CerereTypeService,
        private registreService: RegistreService
    ) {
        this.processToken();
    }

    ngOnInit(): void {
        this.editorConfig = initializeEditor();
        this.loadDocumentCereriTypes();
        this.loadDocumentRegistre();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.componentService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const {
            name,
            context_cetatean,
            context,
            type_id,
            registru_id,
            is_address,
            registru_necessary,
            document_generabil_dual,
        } = this.form.value as objectAddPayload;
        const newObject: objectAddPayload = {
            type_id,
            name,
            context_cetatean,
            context,
            registru_id,
            is_address,
            registru_necessary,
            document_generabil_dual,
        };
        // console.log(this.form.value);
        // this.isLoading = false
        // return false

        this.componentService
            .store(newObject)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
    onAdresaChange(option: any) {

        this.form.get('is_address')?.setValue(option.value);
    }

    onRegistruChange(option: any) {
        this.form.get('registru_necessary')?.setValue(option.value);
        this.form.patchValue({
            registru_id: option.value == false ? '' : this.form.value.registru_id,
            registru_necessary: option.value
        })
    }

    onDualChange(option: any) {
        this.form.get('document_generabil_dual')?.setValue(option.value);
        this.form.patchValue({
            destination: option.value == false ? 'toPrimarie' : this.form.value.destination,
            document_generabil_dual: option.value
        })
        if (option.value == false) {
            this.destination = 'toPrimarie';
        }
    }

    onDestinatieChange(option: any) {
        this.destination = option.value;

        const contextTouchedOrDirty =
            this.form.get('context')?.touched || this.form.get('context')?.dirty;
        const contextCetateanTouchedOrDirty =
            this.form.get('context_cetatean')?.touched ||
            this.form.get('context_cetatean')?.dirty;
        const contextHasValue = this.form.get('context')?.value.length > 0;
        const contextCetateanHasValue =
            this.form.get('context_cetatean')?.value.length > 0;

        const shouldConfirmClear =
            (contextTouchedOrDirty && contextHasValue) ||
            (contextCetateanTouchedOrDirty && contextCetateanHasValue);

        const clearContent = () => {
            const patchValues: any = {};
            if (
                option.value === 'toCetatean' &&
                contextCetateanTouchedOrDirty &&
                contextCetateanHasValue
            ) {
                patchValues.context_cetatean = '';
            } else if (
                option.value === 'toPrimarie' &&
                contextTouchedOrDirty &&
                contextHasValue
            ) {
                patchValues.context = '';
            } else if (option.value === 'toate') {
                if (contextTouchedOrDirty && contextHasValue) {
                    patchValues.context = '';
                }
                if (contextCetateanTouchedOrDirty && contextCetateanHasValue) {
                    patchValues.context_cetatean = '';
                }
            }

            this.form.patchValue(patchValues);
            this.destination = option.value;
        };

        // we will decide on this later on the road
        // if (shouldConfirmClear) {
        // 	Swal.fire({
        // 		title: 'Sunteți sigur?',
        // 		text: 'Această acțiune vă șterge conținutul adăugat până la acest moment.',
        // 		icon: 'warning',
        // 		showCancelButton: true,
        // 		confirmButtonColor: '#3085d6',
        // 		cancelButtonColor: '#d33',
        // 		confirmButtonText: 'Da, șterge!',
        // 	}).then((result) => {
        // 		if (result.isConfirmed) {
        // 			clearContent();
        // 			Swal.fire('Șters!', 'Conținutul a fost șters!', 'success');
        // 		}
        // 	});
        // } else {
        // }
    }

    loadDocumentCereriTypes() {
        this.isLoading = true;
        this.cereriTypes$ = this.cerereTypeService.getRecordsList().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }

    loadDocumentRegistre() {
        this.isLoading = true;
        this.registre$ = this.registreService.getRecordsList().pipe(
            map((results: any) => [this.defaultParameter, ...results]),
            finalize(() => (this.isLoading = false))
        );
    }
}
